import React, { useEffect, useState } from "react";
import { RouteComponentProps, useHistory } from "react-router-dom";
import * as Sentry from "@sentry/browser";

export const SsoErrorScreen: React.FC<RouteComponentProps> = () => {
  const history = useHistory<{
    providerName: string;
    error: string;
    desc: string;
  }>();
  const [providerName, setProviderName] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [errDesc, setErrDesc] = useState<string | null>(null);
  const [showContactSemgrep, setShowContactSemgrep] = useState<boolean>(true);

  useEffect(() => {
    const qsProviderName: string = history.location.state.providerName;
    const qsError = history.location.state.error;
    const qsErrorDesc = history.location.state.desc;
    setProviderName(qsProviderName);
    setError(qsError);
    setErrDesc(qsErrorDesc);

    let updatedDesc = qsErrorDesc;
    let showSupport = true;

    switch (qsErrorDesc) {
      case "Could not process SAML parameters. Missing attribute: email":
      case "Could not process SAML parameters. Missing attribute: name":
        updatedDesc +=
          "\nSee: https://semgrep.dev/docs/kb/semgrep-cloud-platform/sso-attribute-error/";
        showSupport = false;
        break;
      case "There is no AttributeStatement on the Response":
        updatedDesc +=
          "\nSee: https://semgrep.dev/docs/kb/semgrep-cloud-platform/saml-attributestatement/";
        showSupport = false;
        break;
      case "Signature validation failed. SAML Response rejected":
        updatedDesc +=
          "\nSee: https://semgrep.dev/docs/kb/semgrep-cloud-platform/saml-bad-signature/";
        showSupport = false;
        break;
      case "User is not assigned to the client application.":
        updatedDesc +=
          "\nContact your SSO Administrator for permission to access Semgrep Cloud.";
        showSupport = false;
        break;
      default:
        // For any other error, keep the description unchanged
        break;
    }

    setErrDesc(updatedDesc);
    setShowContactSemgrep(showSupport);

    Sentry.captureMessage(
      `CSE: User with SSO '${qsProviderName}' encountered error: '${qsError}' with description: '${qsErrorDesc}'`
    );
  }, [history.location]);
  return (
    <div style={{ padding: "80px", fontSize: "large" }}>
      <h1>SSO Error</h1>
      Semgrep encountered an SSO error{" "}
      <strong>
        <code>{error}</code>
      </strong>
      .{" "}
      {showContactSemgrep && (
        <>
          <a href="/docs/support">Please contact Semgrep Support </a>
        </>
      )}
      <br />
      <br />
      <h3>ProviderName</h3>
      <pre>{providerName}</pre>
      <h3>Description</h3>
      <pre>{errDesc}</pre>
    </div>
  );
};
